import React, { ReactNode } from 'react';
import { PromoterTypes } from '@mm/state/model/PromoterModel';

export type PromoterInfo = {
  media: ReactNode;
  heading: string;
  description: string;
  type: string;
};

export const promotersInfo: PromoterInfo[] = [
  {
    media: (
      <i className="far fa-check-square fa-9x promoter-type-modal__promoter-icon" />
    ),
    heading: 'Checkbox Plugin',
    description:
      'Collect contacts on existing lead and confirmation forms by allowing people' +
      ' to opt in to receiving updates from your business.',
    type: PromoterTypes.CHECKBOX,
  },
  {
    media: (
      <i className="far fa-paper-plane fa-9x promoter-type-modal__promoter-icon" />
    ),
    heading: 'Send to Messenger Button',
    description:
      'A button that sends a MobileMonkey page to users who click it while signed in with Facebook',
    type: PromoterTypes.MESSENGER,
  },
];
